import {Component, Input} from '@angular/core';
import {IconifyComponent} from '../../../../../shared/standalone-components/iconography/iconify/iconify.component';
import {NgClass} from '@angular/common';

@Component({
  selector: 'bor-global-standards-section',
  imports: [
    IconifyComponent,
    NgClass
  ],
  templateUrl: './global-standards-section.component.html',
  styleUrl: './global-standards-section.component.scss',
  host: { class: 'home-sections' }
})
export class GlobalStandardsSectionComponent {
  @Input() isPage = false;

  jsonSample = `{
  "statementID": "nga-psc-9048-cama2020",
  "statementType": "ownershipOrControl",
  "subject": { "describedByEntityStatement": "nga-rc-110492" },
  "interestedParty": { "describedByPersonStatement": "nga-psc-sarah-ade" },
  "interests": [{ "type": "shareholding", "shareValue": 55.4 }]
}`

}
